import { connect } from 'react-redux';
import { getVillageId, getCountrysideBuilderLandingPromoData } from '../../selectors';
import { IState } from '../../store';

import { IMainProps, Main } from './index';
import { isCountrysideCardIntegrated } from '../../utils/countrysideCardIntegration';

export function mapStateToProps(state: IState): IMainProps {
  const villageId = getVillageId(state);

  return {
    offer: state.offerData.offer,
    user: state.offerData.user,
    isOpenCommentBlock: state.commentsData.isOpen,
    isCountrysideCardIntegrated: isCountrysideCardIntegrated(state),
    countrysideBuilderLandingPromoData: villageId ? getCountrysideBuilderLandingPromoData(state, villageId) : null,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MainContainer = connect<IMainProps, any, any>(mapStateToProps)(Main);
